<template>
  <!--新增对话框-->
  <el-dialog title="设置商户" :visible.sync="dialogVisible" width="900px" append-to-body :close-on-click-modal="false"
    :before-close="handleClose">
    <el-form>
      <el-form-item label="姓名" prop="name" label-width="100px">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属地区" prop="region" label-width="100px">
        <el-input v-model="editForm.region" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <el-form ref="editForm" label-width="100px" class="demo-editForm">
      <el-form-item label="选择商户">
        <el-checkbox @change="cheng(item)" v-for="item in user" :key="item.userId" :label="item.nickName"
          v-model="item.checked"></el-checkbox>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="primary" @click="submitForm()">
          确定
        </el-button>
        <el-button @click="resetForm()">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      user: [],
      dialogVisible: false,
      ids: [],

      managerId: '',
      editForm: {
        region: '',
        name: '',
      },
      getCouponsStoreGoodsvisible: false,
    }
  },
  methods: {
    getUserList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$axios.get('/admin/manager/unmanagedMerchants').then((res) => {
        this.user = res.data
        loading.close()
      })
    },
    resetForm() {
      this.dialogVisible = false
      this.user = []
      this.ids = []
      this.searchForm = {}
    },
    handleClose() {
      this.resetForm()
    },
    submitForm() {
      var self = this
      self.$axios
        .post('/admin/manager/setManager', {
          name: self.editForm.name,
          region: self.editForm.region,
          userId: self.managerId,
        })
        .then((res) => {
          self.$axios
            .post('/admin/manager/relatedBusinesses', {
              managerId: self.managerId,
              merchantsId: self.ids,
            })
            .then((res) => {
              self.$message({
                showClose: true,
                message: '恭喜你，操作成功',
                type: 'success',
                onClose: () => {
                  self.$emit('refreshDataList')
                },
              })
              self.dialogVisible = false
              self.resetForm()
            })
        })
    },
    cheng(item) {
      console.log(item)
      if (item.checked) {
        this.ids.push(item.userId)
      } else {
        this.ids.map((item1, index) => {
          if (item.userId == item1) {
            this.ids.splice(index, 1)
          }
        })
      }
      console.log(this.ids)
    },
    init(id) {
      this.dialogVisible = true
      this.user = []
      this.managerId = id
      this.ids = []
      this.$axios
        .post('/admin/manager/findManagerInfo', { userId: id })
        .then((res) => {
          if (res.code == 0 && res.data !== null) {
            this.editForm.region = res.data.region
            this.editForm.name = res.data.name
          }
        })
      this.$axios
        .post('/admin/manager/findMerchants', { managerId: id })
        .then((res) => {
          if (res.code == 0 && res.data.length > 0) {
            res.data.forEach((i) => {
              i.checked = true
              this.ids.push(i.userId)
            })
          }

          this.user.push.apply(this.user, res.data)
        })
      this.$axios.get('/admin/manager/unmanagedMerchants').then((res) => {
        var k = []
        res.data.forEach((i) => {
          if (i !== null) {
            k.push(i)
          }
        })
        this.user.push.apply(this.user, k)
      })
    },
  },
}
</script>

<style scoped></style>
